import {
  FETCH_RETURN_ORDER,
  RESET_RETURN_ORDER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const returnOrderView = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RETURN_ORDER:
      return { data: action.payload };
    case RESET_RETURN_ORDER:
      return initialState;
    default:
      return state;
  }
};

export default returnOrderView;
